<template>
  <b-overlay
    variant="light"
    :show="submitting"
    spinner-variant="primary"
    blur="0"
    opacity="1"
    z-index="1000"
    rounded="sm"
  >
    <b-card>
      <b-row>
        <b-col md="3">
          <b-form-group label="User Type">
            <b-form-radio-group
              v-model="configs.userType"
              :options="usersTypes"
            />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="Transaction Operation">
            <b-form-radio-group
              v-model="configs.transactionOperation"
              :options="transactionOperations"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <BulksTable
        :search-by="configs.userType"
        @file-ready="submit"
      />
    </b-card>
  </b-overlay>
</template>

<script>
import {
  BFormRadioGroup, BFormGroup, BRow, BCol, BCard, BOverlay,
} from 'bootstrap-vue'
import { ref, reactive } from '@vue/composition-api'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import store from '@/views/billing/billingStore'
import BulksTable from './BulksTable.vue'

export default {
  components: {
    BFormRadioGroup, BFormGroup, BRow, BCol, BCard, BulksTable, BOverlay,
  },
  methods: {
    async submit(file) {
      this.submitting = true
      setTimeout(async () => {
        try {
          await this.$store.dispatch('billing/addtransactionBulks', {
            transactionOperation: this.configs.transactionOperation,
            file,
          })
          this.$swal({
            title: 'Success!',
            text: 'Transaction bulk completed',
            icon: 'success',
            customClass: {
              confirmButton: 'btn btn-primary',
              cancelButton: 'btn btn-outline-danger ml-1',
            },
            buttonsStyling: false,
          })
          this.$router.push('/drivers')
        } finally {
          this.submitting = false
        }
      }, 2000)
    },
  },
  setup() {
    useRegisterStoreModule('billing', store)
    const submitting = ref(false)
    const configs = reactive({
      transactionOperation: 'add',
      userType: 'users',
    })
    const transactionOperations = [
      {
        text: 'Add',
        value: 'add',
      },
      {
        text: 'Deduct',
        value: 'deduct',
      },
    ]
    const usersTypes = [
      {
        text: 'Users',
        value: 'users',
      },
      {
        text: 'Drivers',
        value: 'drivers',
      },
    ]

    return {
      transactionOperations,
      usersTypes,
      configs,
      submitting,
    }
  },
}
</script>

<style>

</style>
